<template>
  <!-- 意见反馈 - 新建反馈 author: zhangxiaofeng-->
  <div class="feed-success">
    <div class="success-content">
      <img src="~@/assets/images/tips_ok.png"/>
      <div class="success_title">您的反馈已提交成功！</div>
      <div class="jump_feedback">我们会尽快给您回复，您可以在<a @click="jumpMyFeedback()"><em>我的反馈</em></a>中关注回复进度哦！</div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'FeedbackSuccess',

  data () {
    return {
      user: {}
    }
  },
  methods: {
    jumpMyFeedback () {
      this.$router.push({path: '/feedback/list'})
    }
  },
  mounted () {
    let userinfo = getCookie('ZJYUSERINFO')
    if (userinfo){
      userinfo = JSON.parse(userinfo)
      this.user = userinfo
    }
  }
}
</script>
<style lang="less" type="text/less" scoped>

  .feed-success {
    .success-content {
      text-align: center;

      img {
        margin: 6% auto;
      }

      .success_title {
        font-size: 20px;
        color: #333;
        font-weight: bold;
        margin: 15px 0;
      }

      .jump_feedback {
        font-size: 16px;
        color: #333;
      }

      .jump_feedback em {
        color: #2BA8FF;
        cursor: pointer;
        font-weight: bold;
      }
    }
  }

</style>
